<div>
	<ng-template #tooltipTemplate>
		<div class="tooltip-container">
			<div class="skill">{{ skill.charAt(0).toUpperCase() + skill.slice(1) }}</div>
			<div>Average: {{ average }}</div>
			@for (level of normalizedLevels; track level) {
				<div class="tooltip-level">
					<div class="level-number">{{ level.level }}</div>
					<div class="bar">
						<div class="color-bar" [ngClass]="'level' + level.level" [style.width.%]="level.percent"></div>
					</div>
					<div class="percent">{{ level.percent | number: '1.0-2' }}%</div>
				</div>
			}
		</div>
	</ng-template>

	<div class="container" nz-tooltip [nzTooltipTitle]="tooltipTemplate">
		@for (level of normalizedLevels; track level) {
			@if (level.percent > 0) {
				<div class="level-segment" [ngClass]="'level' + level.level" [style.width.%]="level.percent"></div>
			}
		}
	</div>
</div>
